export const OUTLIER_EXPLANATION =
    "Those earnings calls whose evasion % is statistically significantly higher than the company's historical patterns."
export const OUTLIER_PREDICTIVE_EXPLANATION =
    "Proprietary model flagging that a company's stock has meaningfully underperformed in the 180 days following an outlier based on analysis of past outliers."
